import indexDealer from "@/views/indexDealer";
import view404 from "@/views/view404";
import store from "@/store";
export const Dealer = () =>
  import(
    /* webpackChunkName: "adminPages" */ "@/components/dealer/CustomerDetailsTable"
  );

export const Profile = () =>
  import(/* webpackChunkName: "adminPages" */ "@/components/dealer/Profile");
export const PondMothers = () =>
  import(
    /* webpackChunkName: "adminPages" */ "@/components/dealer/PondMotherTab"
  );
export const PondGuards = () =>
  import(
    /* webpackChunkName: "adminPages" */ "@/components/dealer/PondGuardTab"
  );
export const ShrimpTalks = () =>
  import(
    /* webpackChunkName: "adminPages" */ "@/components/dealer/ShrimpTalkTab"
  );
export const Gateways = () =>
  import(/* webpackChunkName: "adminPages" */ "@/components/dealer/GatewayTab");

const permissions = {
  manage_pond: "MANAGE_POND",
  manage_culture: "MANAGE_CULTURE",
  manage_resources: "MANAGE_RESOURCES",
  perform_lab_test: "PERFORM_LAB_TEST",
  perform_harvest: "PERFORM_HARVEST",
  perform_inputs: "PERFORM_INPUTS",
  add_pond: "ADD_POND",
};

const userTypes = {
  admin: "ADMIN",
  pond_owner: "POND_OWNER",
  pond_worker: "POND_WORKER",
  pond_technician: "POND_TECHNICIAN",
  pond_manager: "POND_MANAGER",
  no_access: "NO_ACCESS",
  super_admin: "SUPER_ADMIN",
  dealer: "DEALER",
  account_manager: "ACCOUNT_MANAGER",
};
const allUserTypes = () => [
  userTypes.admin,
  userTypes.pond_owner,
  userTypes.pond_manager,
  userTypes.pond_worker,
  userTypes.pond_technician,
];
const allPermissions = () => Object.values(permissions);

const signout = () => {
  store.dispatch("auth/signOut").catch((err) => {
    console.error(err);
    throw err;
  });
};
const defaultPagesBasedOnUserType = (userType, next) => {
  switch (userType) {
    case userTypes.super_admin:
      return "/admin/customers";
    case userType.no_access:
      signout();
      return "/sign-in";
    default:
      return "/user/dashboard";
  }
};
const doesUserCanAccess = function(to, from, next) {
  try {
    // const userProfileObj = store.getters["user/getUserProfile"];
    // if (!userProfileObj) {
    //   signout();
    //   return next("/sign-in");
    // }
    // const prsntUserType = userProfileObj.user_type;
    // const pageAllowedUserType = to.meta.userTypeAllowed;
    // if (pageAllowedUserType.indexOf(prsntUserType) === -1) {
    //   // call404Page("User Type Not Allowed")
    //   return next(defaultPagesBasedOnUserType(prsntUserType, next));
    // }
    // const hasLocations = Object.keys(store.getters["user/getUserLocationsObj"])
    //   .length;
    // if (to.meta.dependOnLocations && !hasLocations) {
    //   return next("/user/no-ponds");
    // }
    // const isPermissionRequired = to.meta.isPermissionRequired;
    // if (!isPermissionRequired) {
    //   return next();
    // }
    // const pageRequiredPermissions = to.meta.permissions;
    // const hasPermissions = (permission) => {
    //   return pageRequiredPermissions.indexOf(permission) > -1;
    // };
    // const doesUserHasPermissionToAccessPage = userProfileObj.permissions.some(
    //   hasPermissions
    // );
    // if (!doesUserHasPermissionToAccessPage) {
    //   // call404Page("User Type Not Allowed")
    //   return next(defaultPagesBasedOnUserType(prsntUserType));
    // }
    return next();
  } catch (err) {
    console.error("Check the flow logic and user permissions of the router");
  }
};

export default {
  path: "/dealer",
  component: indexDealer,
  children: [
    {
      path: "/",
      redirect: "users",
    },
    {
      path: "users",
      name: "users",
      component: Dealer,
      meta: {
        permissions: allPermissions(),
        userTypeAllowed: allUserTypes(),
        dependOnLocations: true,
        langKey: "DL_customers",
        isPermissionRequired: true,
      },
      beforeEnter: doesUserCanAccess,
    },
    {
      path: "profile",
      name: "profile",
      component: Profile,
      meta: {
        permissions: allPermissions(),
        userTypeAllowed: allUserTypes(),
        dependOnLocations: true,
        langKey: "Comn_devices",
        isPermissionRequired: true,
      },
      beforeEnter: doesUserCanAccess,
    },
    {
      path: "pondmothers",
      name: "pondmothers",
      component: PondMothers,
      meta: {
        permissions: allPermissions(),
        userTypeAllowed: allUserTypes(),
        dependOnLocations: true,
        langKey: "Comn_pond_mother",
        isPermissionRequired: true,
      },
      beforeEnter: doesUserCanAccess,
    },
    {
      path: "pondguards",
      name: "pondguards",
      component: PondGuards,
      meta: {
        permissions: allPermissions(),
        userTypeAllowed: allUserTypes(),
        dependOnLocations: true,
        langKey: "Comn_pond_guard",
        isPermissionRequired: true,
      },
      beforeEnter: doesUserCanAccess,
    },
    {
      path: "shrimptalks",
      name: "shrimptalks",
      component: ShrimpTalks,
      meta: {
        permissions: allPermissions(),
        userTypeAllowed: allUserTypes(),
        dependOnLocations: true,
        langKey: "Comn_shrimptalk",
        isPermissionRequired: true,
      },
      beforeEnter: doesUserCanAccess,
    },
    {
      path: "gateways",
      name: "gateways",
      component: Gateways,
      meta: {
        permissions: allPermissions(),
        userTypeAllowed: allUserTypes(),
        dependOnLocations: true,
        langKey: "Comn_gateway",
        isPermissionRequired: true,
      },
      beforeEnter: doesUserCanAccess,
    },
    // {
    //   path: "profile",
    //   name: "profile",
    //   component: Profile,
    //   meta: {
    //     permissions: allPermissions(),
    //     userTypeAllowed: allUserTypes(),
    //     dependOnLocations: true,
    //     langKey: "Comn_devices",
    //     isPermissionRequired: true,
    //   },
    //   beforeEnter: doesUserCanAccess,
    // },
    // {
    //   path: "profile",
    //   name: "profile",
    //   component: Profile,
    //   meta: {
    //     permissions: allPermissions(),
    //     userTypeAllowed: allUserTypes(),
    //     dependOnLocations: true,
    //     langKey: "Comn_devices",
    //     isPermissionRequired: true,
    //   },
    //   beforeEnter: doesUserCanAccess,
    // },
    // {
    //   path: "profile",
    //   name: "profile",
    //   component: Profile,
    //   meta: {
    //     permissions: allPermissions(),
    //     userTypeAllowed: allUserTypes(),
    //     dependOnLocations: true,
    //     langKey: "Comn_devices",
    //     isPermissionRequired: true,
    //   },
    //   beforeEnter: doesUserCanAccess,
    // },

    {
      path: "404",
      name: "admin404",
      component: view404,
      meta: {
        langKey: "PondLogs",
      },
    },
  ],
};
